<script lang="ts">
  import * as _ from "lodash";

  // types
  import type { Invoice } from "@shared/types/Invoice";

  // services
  import { getDisplayAmount } from "@retailer/services/invoice_service";

  // props
  export let invoice: Invoice;

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  $: creditUsageTransfers = invoice.payment_transfers?.filter(
    pt => pt.transfer_type == "credit_usage"
  );
  $: payment = invoice.total_scheduled_payment
    ? invoice.total_scheduled_payment
    : invoice.debit_paid?.amount;
  $: totalDiscount = _.sum(invoice.line_items?.map(item => parseFloat(item.total_discount)));
  $: showPaymentDetails = ["scheduled", "paid", "pending"].includes(invoice.invoice_status_type);

</script>

<div class="fizz-flex-row fizz-justify-end fizz-stack-24 fizz-inset-horizontal-24">
  <table class="fizz-text-medium fizz-table-compact" style="max-width: 360px;">
    {#if totalDiscount > 0}
      <thead>
        <tr>
          <td colspan="2" class="fizz-text-deal">
            <div class="fizz-flex-row-8">
              <Icon type="Stars" height="16" width="16" fill="#078854" />
              <span
                ><strong>Congrats!</strong> You saved <FormatMoney
                  input={totalDiscount}
                  formatType={"5"}
                /> on this order.</span
              >
            </div>
          </td>
        </tr>
      </thead>
    {/if}
    <tbody>
      <tr>
        <th>Tax</th>
        <td class="fizz-align-right">
          <p data-testid="total-tax-amount">
            <FormatMoney input={invoice.tax} formatType={"5"} />
          </p>
        </td>
      </tr>
      <tr>
        <th>Fees</th>
        <td class="fizz-align-right">
          <p data-testid="total-fees-amount">
            <FormatMoney input={invoice.fees} formatType={"5"} />
          </p>
        </td>
      </tr>
      <tr>
        <th>Invoice Total</th>
        <td class="fizz-align-right">
          <strong data-testid="total-invoice-amount">
            <FormatMoney input={parseFloat(getDisplayAmount(invoice))} formatType={"5"} />
          </strong>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="fizz-flex-row fizz-justify-end fizz-stack-24 fizz-inset-horizontal-24">
  {#if showPaymentDetails}
    <table class="fizz-text-medium fizz-table-compact" style="max-width: 360px;">
      <tbody>
        {#each creditUsageTransfers as creditUsageTransfer}
          {#each creditUsageTransfer.credit_redemptions as redemption, i}
            <tr>
              <td>
                <p data-testid={"redemption-label-" + i}>
                  <UIRouterLink
                    stateName={`layout.credit_details`}
                    params={{ invoiceId: redemption.credit_invoice.id }}
                    classes={"fizz-text-medium"}
                  >
                    Credit #{redemption.credit_invoice.invoice_reference_id}
                  </UIRouterLink>
                  {#if creditUsageTransfer.status == "succeeded"}applied{:else}to be applied{/if}
                </p>
              </td>

              <td class="fizz-align-right">
                <p data-testid={"redemption-amount-" + i}>
                  <FormatMoney input={-redemption.amount} formatType={"5"} />
                </p>
              </td>
            </tr>
          {/each}
        {/each}
        <tr>
          <th
            >Total {#if invoice.invoice_status_type == "scheduled" || invoice.invoice_status_type == "pending"}Scheduled
            {/if}Payment</th
          >
          <td class="fizz-align-right">
            <strong data-testid="payment-total">
              <FormatMoney input={payment} formatType={"5"} />
            </strong>
          </td>
        </tr>
      </tbody>
    </table>
  {/if}
</div>
